module.exports = __webpack_public_path__ + "static/media/Galileo_itemUp.887afccf.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/Galileo_itemUp.wav
// module id = 192
// module chunks = 0